import {
  providerForConnection,
  type PublicConnectionProviderId,
} from "./profile-connections";
import { publicAssetUrl } from "../../lib/public-asset-url";

export function ProfileConnectionMark({
  providerId,
  className = "h-4 w-4",
}: {
  providerId: PublicConnectionProviderId;
  className?: string;
}) {
  const provider = providerForConnection(providerId);
  if (!provider?.assetPath) return null;
  return (
    <img
      src={publicAssetUrl(provider.assetPath)}
      alt=""
      aria-hidden="true"
      data-profile-connection-provider={providerId}
      className={`${className} shrink-0 object-contain`}
    />
  );
}
